module.exports = __webpack_public_path__ + "img/down_guide2.38523340.png";